import React from 'react';

type Props = {
  code: string;
  variant?: 'stacked' | 'inline';
};

function DropOffCode({ code, variant = 'stacked' }: Props) {
  if (variant === 'inline') {
    return (
      <span>
        <span className="text-gray-500">{gettext('Drop-off code')}:</span>{' '}
        <span className="font-mono font-bold tracking-wider text-indigo-600">{code}</span>
      </span>
    );
  }

  return (
    <div className="flex flex-col items-center">
      <div className="text-sm text-gray-500">{gettext('Drop-off code')}</div>
      <div className="text-2xl font-bold font-mono tracking-wider text-indigo-600">{code}</div>
    </div>
  );
}

export default DropOffCode;
